(function () {
    const isMobile = () => /Android|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent);

    const scannerElement = document.querySelector(".steps-wrapper__scanner");
    const scanBtn = document.getElementById('scanBtn');
    const reader = document.getElementById('reader');
    const closeReaderBtn = document.getElementById('closeReaderBtn');

    if (!isMobile()) {
        if (scannerElement) {
            scannerElement.style.display = "none";
        }
        return;
    }

    let html5Qrcode = null;

    function stopReader() {
        if (html5Qrcode) {
            try { html5Qrcode.stop().catch(() => { }); } catch (e) { }
            html5Qrcode = null;
        }
        if (reader) reader.style.display = "none";
        if (closeReaderBtn) closeReaderBtn.style.display = "none";
    }

    if (closeReaderBtn) {
        closeReaderBtn.addEventListener('click', stopReader);
    }

    if (scanBtn) {
        scanBtn.addEventListener('click', function () {
            if (html5Qrcode) {
                try { html5Qrcode.stop().catch(() => { }); } catch (e) { }
            }
            html5Qrcode = new Html5Qrcode("reader");
            if (reader) reader.style.display = "block";
            if (closeReaderBtn) closeReaderBtn.style.display = "block";
            html5Qrcode.start(
                { facingMode: "environment" },
                { fps: 10, qrbox: { width: 250, height: 250 } },
                function (decodedText) {
                    stopReader();
                    let url;
                    try {
                        url = new URL(decodedText);
                    } catch {
                        console.warn("QR code did not contain a valid URL:", decodedText);
                        return;
                    }
                    if (url.protocol !== "https:" && url.protocol !== "http:") {
                        console.warn("QR code URL has an unsafe protocol:", url.protocol);
                        return;
                    }
                    const confirmText = scanBtn.dataset.confirm;
                    if (confirm(`${confirmText}\n\n${decodedText}`)) {
                        window.location.href = url.href;
                    }
                }
            ).catch(function (err) {
                console.error("Failed to start QR scanner:", err);
                stopReader();
            });
        });
    }
}());